import React, { ReactElement } from 'react';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import { CommunityProvider } from 'lib/contexts/community-context';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';
import CommunityDashboard from './CommunityDashboard';

const CommunityPage = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Community - Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <CommunityProvider>
        <CommunityDashboard />
      </CommunityProvider>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.TOOL_COMMUNITY, LOCALE_PAGES.COMMON],
      })),
    },
  };
}

const Community = withAuth(CommunityPage);

// @ts-ignore
Community.getLayout = getLayout;

export default Community;
